// extracted by mini-css-extract-plugin
export default {"title":"L3-z","warning":"M3-z","sizeOptionsLegendText":"N3-z"};